import React from 'react';
import { ICON_REGISTRY, HelpCircle } from './iconRegistry';

// Icons resolve from a curated, tree-shaken registry (src/components/
// iconRegistry.js) instead of a `import * as LucideIcons` barrel — the barrel
// pulled the entire lucide-react set (~1.3 MB source) into the homepage entry
// chunk. Unknown names fall back to <HelpCircle/>, exactly as before.
function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = name ? ICON_REGISTRY?.[name] : null;

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;
